document.addEventListener('DOMContentLoaded', (event) => {
  console.log(`Documents d'artistes Bretagne - 2021\nSilex Taille Numérique\n`)
})

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

import artists from './artists.js'
import carousel from './carousel.js'
import masonry from './masonry.js'
import iframe from './iframe.js'
import multiline from './x-multiline.js'
import url from './url.js'
import menu from './menu.js'
import search from './search.js'
import lightbox from './lightbox.js'
import viewport from './viewport.js'

document.addEventListener('alpine:init', () => {
  Alpine.magic('getContentWidth', () => ($element) => {
    return Array.from($element.children)
      .map((children) => children.offsetWidth)
      .reduce((childWidth, width) => width + childWidth)
  })

  Alpine.plugin(intersect)

  Alpine.data('artists', artists)
  Alpine.data('carousel', carousel)
  Alpine.data('masonry', masonry)
  Alpine.data('iframe', iframe)
  Alpine.data('lightbox', lightbox)

  Alpine.store('url', url)
  Alpine.store('menu', menu)
  Alpine.store('search', search)
  Alpine.store('viewport', viewport)

  Alpine.directive('multiline', multiline)
})

window.Alpine = Alpine
window.Alpine.start()
